import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";
import React from "react";
//import BigCalendar from "react-big-calendar";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import {
  getAllCalendarEventsAction,
  getTransactionDataAction,
  deleteTaskAction,
} from "./../../actions/TransactionActions";
import "./../../assets/scss/plugins/_plugin-react-big-calendar.scss";
import TaskDetail from "./../Transactions/Detail/task-detail";
import { getTimeFromMins } from "./../Common/Common";
import * as message from "./../../config/CommonMessages";

//const localizer = BigCalendar.momentLocalizer(moment);
const localizer = momentLocalizer(moment);

class CalendarModule extends React.Component {
  constructor(props) {
    super(props);

    this.setStartDate = this.setStartDate.bind(this);
    this.setEndDate = this.setEndDate.bind(this);
    this.state = {
      events: [],
      alert: null,
      addTask: "",
      startDate: moment(),
      closeDate: moment().subtract(-29, "days"),
      viewTask: false,
      viewState: "month",
      taskId: "",
      transactionData: {},
      showLoader: false,
      defaultView: "month",
      defaultDate: new Date(),
    };
    this.hideAlert = this.hideAlert.bind(this);
    this.formats = {
      eventTimeRangeFormat: (e) => {
        return moment(e.start).format("h:mm A");
      },
    };
  }

  setStartDate(event, picker) {
    this.setState({
      startDate: picker.startDate,
    });
  }

  setEndDate(event, picker) {
    this.setState({
      closeDate: picker.startDate,
    });
  }

  toggleTask = (i) => {
    if (i == 0) {
      this.setState({ addTask: "open" });
    } else {
      this.setState({ addTask: "" });
    }
  };

  // view task modal
  selectedEvent(event) {
    this.setState({ viewTask: false });
    this.props.getTransactionDataAction(event.transactionId).then((res) => {
      if (res) {
        this.setState({
          viewTask: true,
          transactionData: res,
          taskId: event._id,
        });
      }
    });
  }

  /**
   * @desc api call to get all calender events
   * create event array with event data and color which is based on event status
   * load calender events to calendar
   */
  loadCalendarEvents() {
    this.setState({ showLoader: true });
    this.props.getAllCalendarEventsAction().then(
      (res) => {
        var events = [];
        if (res) {
          res.forEach((tr) => {
            tr.forEach((e) => {
              e.eventEndDate = new Date(
                moment(e.eventEndDate).format("MM/DD/YYYY ") +
                  getTimeFromMins(e.time)
              );
              var color = "blue";
              if (e.status == "SCHEDULED") {
                color = "blue";
                if (moment(e.eventEndDate) < moment()) {
                  color = "orange";
                }
              } else if (e.status == "COMPLETED") {
                color = "green";
              }
              events.push({
                title: e.title,
                allDay: false,
                start: new Date(
                  moment(e.eventEndDate).get("year"),
                  moment(e.eventEndDate).get("month"),
                  moment(e.eventEndDate).get("date"),
                  moment(e.eventEndDate).get("hour"),
                  moment(e.eventEndDate).get("minutes")
                ), //'2019-08-02',
                end: new Date(
                  moment(e.eventEndDate).get("year"),
                  moment(e.eventEndDate).get("month"),
                  moment(e.eventEndDate).get("date"),
                  moment(e.eventEndDate).get("hour"),
                  moment(e.eventEndDate).get("minutes")
                ),
                color: color,
                _id: e._id,
                transactionId: e.transactionId,
              });
            });
          });
          this.setState({
            events,
            showLoader: false,
          });
        }
      },
      (error) => {
        this.setState({
          showLoader: false,
        });
      }
    );
  }

  addNewEventAlert(slotInfo) {
    this.toggleTask(0);
  }

  /**
   * @desc add new event to calendar
   */
  addNewEvent(e, slotInfo) {
    var newEvents = this.state.events;
    newEvents.push({
      title: e,
      start: slotInfo.start,
      end: slotInfo.end,
    });
    this.setState({
      alert: null,
      events: newEvents,
    });
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  deleteTask(id) {
    this.setState({ viewTask: false });
    this.props.deleteTaskAction(id).then((res) => {
      this.loadCalendarEvents();
    });
  }

  eventColors(event, start, end, isSelected) {
    var backgroundColor = "event-";
    event.color
      ? (backgroundColor = backgroundColor + event.color)
      : (backgroundColor = backgroundColor + "default");
    return {
      className: backgroundColor,
    };
  }

  componentWillMount() {
    //check if timestamp attached with params then load that data to calendar
    let dateParam = this.props.match.params.date;
    if (dateParam !== undefined) {
      dateParam = parseInt(dateParam);
      let date =
        new Date(dateParam) != "Invalid Date"
          ? new Date(dateParam)
          : new Date();
      this.setState({
        defaultView: "day",
        viewState: "day",
        defaultDate: date,
      });
    }
    this.loadCalendarEvents();
  }

  /**
   * @desc change view of calendar
   */
  changeView(view, toolbar) {
    toolbar.onView(view);
    this.setState({ viewState: view });
  }

  render() {
    const CustomToolbar = (toolbar) => {
      const goToBack = () => {
        toolbar.onNavigate("PREV");
      };

      const goToNext = () => {
        toolbar.onNavigate("NEXT");
      };

      const goToCurrent = () => {
        toolbar.onNavigate("TODAY");
      };

      const label = () => {
        return <span>{toolbar.label}</span>;
      };

      return (
        <div className="rbc-calendar">
          <div className="rbc-toolbar d-block">
            <Row className="justify-content-between align-items-center">
              <Col xs={12} sm={4}>
                <span className="rbc-btn-group d-flex">
                  <button type="button" onClick={goToCurrent}>
                    Today
                  </button>
                </span>
              </Col>
              <Col xs={12} sm={4} className="px-0">
                <span className="rbc-toolbar-label">
                  <button type="button" onClick={goToBack}>
                    <KeyboardArrowLeft />
                  </button>
                  {label()}
                  <button type="button" onClick={goToNext}>
                    <KeyboardArrowRight />
                  </button>
                </span>
              </Col>
              <Col xs={12} sm={4} align="right">
                <span className="rbc-btn-group cal-view">
                  <button
                    type="button"
                    className={this.state.viewState == "day" && "rbc-active"}
                    onClick={() => this.changeView("day", toolbar)}
                  >
                    Day
                  </button>
                  <button
                    type="button"
                    className={this.state.viewState == "week" && "rbc-active"}
                    onClick={() => this.changeView("week", toolbar)}
                  >
                    Week
                  </button>
                  <button
                    type="button"
                    className={this.state.viewState == "month" && "rbc-active"}
                    onClick={() => this.changeView("month", toolbar)}
                  >
                    Month
                  </button>
                </span>
              </Col>
            </Row>
          </div>
        </div>
      );
    };
    return (
      <>
        {this.state.showLoader && (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
        <div className="calendar-page">
          <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
            <Col>
              <h4 className="title-med mt-0 pt-1">Calendar</h4>
            </Col>
            <Col align="right">
              <ul className="list-inline status-mark-list mb-0 font-12">
                <li className="status-mark-text d-inline-flex align-items-center mr-2">
                  <span className="status-mark status-mark-blue" />
                  Scheduled Tasks
                </li>
                <li className="status-mark-text d-inline-flex align-items-center mr-2">
                  <span className="status-mark status-mark-orange" />
                  Overdue Tasks
                </li>
                <li className="status-mark-text d-inline-flex align-items-center mr-2">
                  <span className="status-mark status-mark-green" />
                  Completed Tasks
                </li>
              </ul>
            </Col>
          </Row>
          <div className="admin-content-area mt-10">
            {/* calendar */}
            <Calendar
              views={["day", "week", "month"]}
              localizer={localizer}
              selectable
              components={{
                toolbar: CustomToolbar,
              }}
              events={this.state.events}
              defaultView={this.state.defaultView === "day" ? "day" : "month"}
              scrollToTime={new Date(1970, 1, 1, 6)}
              defaultDate={
                this.state.defaultView === "day"
                  ? this.state.defaultDate
                  : new Date()
              }
              onSelectEvent={(event) => this.selectedEvent(event)}
              onSelectSlot={(slotInfo) => this.addNewEventAlert(slotInfo)}
              formats={this.formats}
              tooltipAccessor={(e) => {
                return e.title;
              }}
              titleAccessor={(e) => {
                return moment(e.end).format("h:mm A, ") + e.title;
              }}
              eventPropGetter={this.eventColors}
            />

            {/* View task slide */}
            <div
              className={
                (this.state.viewTask && "open") +
                " calendar-add-task task-single cal-task-slide"
              }
            >
              {this.state.viewTask && (
                <TaskDetail
                  taskId={this.state.taskId}
                  deleteTask={(id) => {
                    this.deleteTask(id);
                  }}
                  onUpdate={(e) => {
                    this.loadCalendarEvents();
                  }}
                  transactionData={this.state.transactionData}
                  fromTimeline={true}
                  closeDetailsModal={() => {
                    this.setState({ viewTask: false });
                  }}
                  permissiontype={message.view_calendar}
                />
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    taskData: state.reducer.taskData,
  };
};

export default connect(
  mapStateToProps,
  { getAllCalendarEventsAction, getTransactionDataAction, deleteTaskAction }
)(CalendarModule);
